<template>
  <div>
    <Head title="Invoicing Queue" />
    <h1 class="mb-8 text-3xl font-bold">Invoicing Queue</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="search.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Role:</label>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3 border border-dark">Date</th>
          <th class="pb-3 pt-3 px-3 border border-dark">DR Number</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Delivery Assistant</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Vehicle number plate</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Volume</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Status</th>
          <th class="pb-3 pt-3 px-3">Created By</th>
          <th class="pb-3 pt-3 px-3 text-end" />
        </tr>
        <tr
          v-for="listp in delivery_runs.data"
          :key="listp.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${listp.delivery_run_id}/details`"
              title=""
            >
              {{ listp.date }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${listp.delivery_run_id}/details`"
              title=""
            >
              {{ listp.number }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${listp.delivery_run_id}/details`"
              title=""
            >
              {{ listp.user }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${listp.delivery_run_id}/details`"
              title=""
            >
              {{ listp.plate_number }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${listp.delivery_run_id}/details`"
              title=""
            >
              {{ listp.volume }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${listp.delivery_run_id}/details`"
              title=""
            >
              {{ listp.status }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${listp.delivery_run_id}/details`"
              title=""
            >
              {{ listp.created_by }}
            </Link>
          </td>
          <td class="w-px border-t">
            <a
              :href="`/invoice-validation/delivery-runs/${listp.delivery_run_id}/details`"
              class="flex items-center justify-end pr-3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="delivery_runs.data.length === 0">
          <td class="px-3 py-3 border-t border border-dark" colspan="6">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="delivery_runs.links" />
  </div>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import SearchFilter from "@/Shared/SearchFilter";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import Pagination from "@/Shared/Pagination";

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    delivery_runs: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        item_id: null,
      }),
      search: {
        search: this.filters.search,
      },
    };
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role;
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get("/invoice-validation-queue/", pickBy(this.search), {
          preserveState: true,
        });
      }, 150),
    },
  },
};
</script>
